export default import.meta.ROLLDOWN_FILE_URL_ydO74Gy16$om$6aLh07BFw